import {
  Select,
} from '@chakra-ui/react';

import { useRecoilState } from 'recoil';
import { selectedCustomReportState } from '@src/modules/performance/state';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCustomReportsList } from '../context/custom-reports-api-hooks';

function CustomReportsSelector() {
  const { data: customReports, isLoading } = useCustomReportsList();
  const [selectedCustomReports, setSelectedCustomReports] = useRecoilState(selectedCustomReportState);
  const { pathname } = useLocation();
  const page = pathname.split('/')[1]?.toLowerCase();
  const filteredReports = customReports?.filter((report) => report.page?.map((p) => p.toLowerCase()).includes(page));
  const selectedReportForPage = selectedCustomReports?.[page] ?? '';

  const handleChange = (e) => {
    const reportId = parseInt(e.target.value, 10);
    setSelectedCustomReports((prev) => ({
      ...prev,
      [page]: reportId,
    }));
  };

  useEffect(() => {
    if (
      filteredReports
      && filteredReports.length > 0
      && !selectedCustomReports?.[page]
    ) {
      setSelectedCustomReports((prev) => ({
        ...prev,
        [page]: filteredReports[0].id,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredReports, page]);

  return (
    <Select
      width="auto"
      isDisabled={isLoading}
      size="sm"
      value={selectedReportForPage}
      onChange={handleChange}
    >
      {filteredReports?.map((report) => (
        <option key={report.id} value={report.id}>
          {report.name}
        </option>
      ))}
    </Select>
  );
}

export default CustomReportsSelector;
